import type { FormListInterface } from '@/modules/core/models/types'

//TODO: Move to common module from foreign-health and health modules
import BetterAssuranceForm from '../views/forms/BetterAssuranceForm.vue'
import AdditionalCoveragesForm from '../views/forms/AdditionalCoveragesForm.vue'

import InsuranceAnotherCompanyDataForm from '@/modules/foreign-health/hiring/views/forms/InsuranceAnotherCompanyDataForm.vue'
import StudentQuestionForm from '../views/forms/StudentQuestionForm.vue'
import MultipleStudentAttachmentForm from '../views/forms/attachmentForms/MultipleStudentAttachmentForm.vue'
import InsurancePersonalDataStep1Form from '@/modules/common/hiring/views/forms/InsurancePersonalDataStep1Form.vue'
import InsurancePersonalDataStep2Form from '@/modules/common/hiring/views/forms/InsurancePersonalDataStep2Form.vue'
import InsurancePersonalDataStep3Form from '@/modules/common/hiring/views/forms/InsurancePersonalDataStep3Form.vue'
import InsurancePersonalDataStep4Form from '@/modules/common/hiring/views/forms/InsurancePersonalDataStep4Form.vue'
import InsurancePersonalDataStep5Form from '@/modules/common/hiring/views/forms/InsurancePersonalDataStep5Form.vue'

import InsuranceBodyMeasurementsForm from '@/modules/common/hiring/views/forms/InsuranceBodyMeasurementsForm.vue'
import Step3MedicalSituationForm from '@/modules/health/hiring/views/pages/Step3MedicalSituationForm.vue'
import Step3HealthConditionsForm from '@/modules/health/hiring/views/pages/Step3HealthConditionsForm.vue'

import ForeignHealthInsuranceProcessStepEnum from '@/modules/foreign-health/hiring/models/APP/ForeignHealthInsuranceProcessStepEnum'
import { UserRoleEnum } from '@/modules/core/models/enums'
import Step0Form from '@/modules/foreign-health/hiring/views/forms/Step0Form.vue'
import { isBigger } from '@/utils/date.utils'
import type ForeignHealthInsured from '@/modules/foreign-health/hiring/models/MID/ForeignHealthInsured'

const validationGuards = {
  isOfAge: (insured: ForeignHealthInsured) => {
    if (insured.role !== UserRoleEnum.INSURED) {
      return true
    }

    const birthDate = insured.userDetails.birthDate
    if (!birthDate) {
      return true
    }

    return isBigger(birthDate, 18)
  }
}

export const STEP0_PAGES: FormListInterface = {
  Step0_1_StartDateForm: {
    form: Step0Form,
    next: ['Step1_1_BetterAssuranceForm'],
    extra: {
      step: 0,
      showActions: false,
      processStep: [ForeignHealthInsuranceProcessStepEnum.RATER],
      minDays: -7,
      addPaddingTop: true
    }
  }
}

export const STEP1_PAGES: FormListInterface = {
  Step1_1_BetterAssuranceForm: {
    form: BetterAssuranceForm,
    next: ['Step2_1_InsuranceAnotherCompanyForm', 'Step1_2_CoveragesForm'],
    extra: {
      step: 1,
      showActions: false,
      processStep: [ForeignHealthInsuranceProcessStepEnum.COVERAGES]
    }
  },
  Step1_2_CoveragesForm: {
    form: AdditionalCoveragesForm,
    next: ['Step2_1_InsuranceAnotherCompanyForm'],
    extra: {
      step: 1,
      showActions: false
    }
  }
}

export const STEP2_PAGES: FormListInterface = {
  Step2_1_InsuranceAnotherCompanyForm: {
    form: InsuranceAnotherCompanyDataForm,
    next: ['Step2_2_StudentQuestionForm'],
    extra: {
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED, UserRoleEnum.INSURED],
      processStep: [
        ForeignHealthInsuranceProcessStepEnum.DOCUMENTS,
        ForeignHealthInsuranceProcessStepEnum.INSUREDS
      ],
      onSubmit: 'sendNotInsuredDocument',
      summarySubStepIndex: 0
    }
  },
  Step2_2_StudentQuestionForm: {
    form: StudentQuestionForm,
    next: ['Step2_3_MultipleStudentAttachmentForm', 'Step2_4_InsurancePersonalDataStep1Form'],
    extra: {
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.INSURED],
      onSubmit: 'sendDocumentNumber',
      summarySubStepIndex: 0
    }
  },
  Step2_3_MultipleStudentAttachmentForm: {
    form: MultipleStudentAttachmentForm,
    next: ['Step2_4_InsurancePersonalDataStep1Form'],
    extra: {
      useCurrentInsured: true,
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.INSURED],
      onSubmit: 'sendPolicyHolderDocument',
      summarySubStepIndex: 0
    }
  },
  Step2_4_InsurancePersonalDataStep1Form: {
    form: InsurancePersonalDataStep1Form,
    next: ['Step2_5_InsurancePersonalDataStep2Form'],
    extra: {
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED, UserRoleEnum.INSURED],
      processStep: [ForeignHealthInsuranceProcessStepEnum.HOLDER],
      // onSubmit: 'checkExistClient',
      summarySubStepIndex: 1
    }
  },
  Step2_5_InsurancePersonalDataStep2Form: {
    form: InsurancePersonalDataStep2Form,
    next: ['Step2_6_InsurancePersonalDataStep3Form'],
    extra: {
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED, UserRoleEnum.INSURED],
      summarySubStepIndex: 2
    }
  },
  Step2_6_InsurancePersonalDataStep3Form: {
    form: InsurancePersonalDataStep3Form,
    next: ['Step2_7_InsurancePersonalDataStep4Form'],
    extra: {
      showActions: false,
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED, UserRoleEnum.INSURED],
      onSubmit: 'sendYoungInsured', //? only for young insureds
      summarySubStepIndex: 2
    }
  },
  Step2_7_InsurancePersonalDataStep4Form: {
    form: InsurancePersonalDataStep4Form,
    next: ['Step2_8_InsurancePersonalDataStep5Form'],
    extra: {
      step: 2,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED, UserRoleEnum.INSURED],
      guards: [validationGuards.isOfAge],
      onSubmit: 'sendInsureds',
      summarySubStepIndex: 3,
      prefixEnable: true
    }
  },
  Step2_8_InsurancePersonalDataStep5Form: {
    form: InsurancePersonalDataStep5Form,
    next: ['Step3_1_InsuranceBodyMeasurementsForm'],
    extra: {
      step: 2,
      hideInsuredSubtitle: true,
      roles: [UserRoleEnum.HOLDER_INSURED, UserRoleEnum.HOLDER_NOT_INSURED],
      onSubmit: 'sendPolicyHolder',
      summarySubStepIndex: 3,
      showByLanguage: true
    }
  }
}

export const STEP3_PAGES: FormListInterface = {
  Step3_1_InsuranceBodyMeasurementsForm: {
    form: InsuranceBodyMeasurementsForm,
    next: ['Step3_2_MedicalSituationForm'],
    extra: { step: 3, processStep: [ForeignHealthInsuranceProcessStepEnum.QUESTIONNAIRES] }
  },
  Step3_2_MedicalSituationForm: {
    form: Step3MedicalSituationForm,
    next: ['Step3_3_HealthConditionsForm'],
    extra: { step: 3 }
  },
  Step3_3_HealthConditionsForm: {
    form: Step3HealthConditionsForm,
    next: [],
    extra: { step: 3, onSubmit: 'sendQuestionnaire' }
  }
}

export default {
  STEP0_PAGES,
  STEP1_PAGES,
  STEP2_PAGES,
  STEP3_PAGES
}
